import { http } from './client'
import type {
  EpisodeResponse,
  PlaybackProgressRequest,
  PlaybackProgressResponse,
  QuotaResponse,
  Uuid,
} from './types'

export const listEpisodes = () => http.get<EpisodeResponse[]>('/v0/episodes/')

export const getQuota = () => http.get<QuotaResponse>('/v0/episodes/quota')

export const deleteEpisode = (id: Uuid) => http.del<void>(`/v0/episodes/${id}`)

export const getProgress = (id: Uuid) =>
  http.get<PlaybackProgressResponse>(`/v0/episodes/${id}/progress`)

// keepalive — для сохранения на pagehide/hidden: запрос доживает до сервера после выгрузки.
export const saveProgress = (
  id: Uuid,
  body: PlaybackProgressRequest,
  options?: { keepalive?: boolean },
) => http.put<PlaybackProgressResponse>(`/v0/episodes/${id}/progress`, body, options)
